"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAutonumberField = exports.getPrefixFromLabel = exports.getFormattedAutonumber = exports.formatAutoNumberValue = void 0;
const date_fns_1 = require("date-fns");
const fast_memoize_1 = __importDefault(require("fast-memoize"));
const application_1 = require("../testing/application");
const fields_1 = require("../utils/fields");
const formatAutoNumberValue = (value, options = {
    leading_zeros: 2,
    prefix: "",
    suffix: "",
    include_labels: false,
}, record) => {
    var _a;
    if (!value) {
        return null;
    }
    const paddedValue = String(value).padStart(((_a = options.leading_zeros) !== null && _a !== void 0 ? _a : 0) + 1, "0");
    if (!options.include_labels) {
        return paddedValue;
    }
    const valueFromRecord = getFirstCreatedValue(record);
    const createdDate = valueFromRecord ? (0, date_fns_1.parseISO)(valueFromRecord) : null;
    const formattedPrefix = replaceTemplateToDateValue(options.prefix, createdDate);
    const formattedSuffix = replaceTemplateToDateValue(options.suffix, createdDate);
    return [formattedPrefix, paddedValue, formattedSuffix]
        .filter(Boolean)
        .join("");
};
exports.formatAutoNumberValue = formatAutoNumberValue;
const searchValues = ["{Y{4}}", "{Y{2}}", "{M{2}}", "{D{2}}"];
const regex = new RegExp(searchValues.join("|"), "g");
const replaceTemplateToDateValue = (str, date) => {
    if (!str) {
        return "";
    }
    const getTemplateValue = (0, fast_memoize_1.default)((template) => {
        if (!date) {
            return template;
        }
        switch (template) {
            case "{YYYY}":
                return String((0, date_fns_1.getYear)(date));
            case "{YY}":
                return String((0, date_fns_1.getYear)(date)).slice(-2);
            case "{MM}":
                return String((0, date_fns_1.getMonth)(date) + 1).padStart(2, "0");
            case "{DD}":
                return String((0, date_fns_1.getDate)(date)).padStart(2, "0");
            default:
                return "";
        }
    });
    return str.replace(regex, (template) => getTemplateValue(template));
};
const getFirstCreatedValue = (record) => {
    const stubFirstCreatedField = (0, application_1.initField)("firstcreatedfield", "First created", "first_created");
    const value = record &&
        (0, fields_1.getValueFromRecordByField)(record, stubFirstCreatedField);
    return value ? value.on : new Date().toISOString();
};
/**
 * @deprecated Use formatAutoNumberValue instead.
 */
const getFormattedAutonumber = (record, autonumberField) => {
    var _a;
    const value = record === null || record === void 0 ? void 0 : record[autonumberField.slug];
    return (_a = (0, exports.formatAutoNumberValue)(value, autonumberField.params)) !== null && _a !== void 0 ? _a : "";
};
exports.getFormattedAutonumber = getFormattedAutonumber;
const getPrefixFromLabel = (label) => {
    return label.replace(/\s/g, "").substring(0, 3).toUpperCase();
};
exports.getPrefixFromLabel = getPrefixFromLabel;
const isAutonumberField = (field) => {
    return field.field_type === "autonumberfield";
};
exports.isAutonumberField = isAutonumberField;
